import { em } from 'polished'
import styled, { css } from 'styled-components'

import FrameMacStraight from 'components/FrameMacStraight'

export const Content = styled.div`
  min-height: 0;
  display: flex;
  align-items: center;

  ${p => p.theme.mq.upMd} {
    min-height: ${p => p.theme.blocks.heightMinResultsMd};
  }

  ${p => p.theme.mq.upLg} {
    min-height: ${p => p.theme.blocks.heightMinResultsLg};
  }
`

export const FrameWrapper = styled.div`
  position: relative;
  min-height: ${p => p.theme.blocks.heightMinResults};
`

export const FrameMacStraightStyled = styled(FrameMacStraight)`
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    margin: 0;
  }
`

export const IconWrapper = styled.div`
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.charts {
    width: ${em(120)};
    height: ${em(120)};
    top: 0;
    right: 0;
    transform: translate(0, -70%);

    ${p => p.theme.mq.upMd} {
      right: 50%;
      transform: translate(50%, -105%) rotate(-25deg);
    }

    ${p => p.theme.mq.upLg} {
      width: ${em(150)};
      height: ${em(150)};
      right: 0;
      transform: translate(-120%, -100%);
    }
  }

  &.profile {
    width: ${em(130)};
    height: ${em(130)};
    bottom: 0;
    left: 0;
    transform: translate(0, 40%) rotate(30deg);

    ${p => p.theme.mq.upMd} {
      transform: translate(20%, 30%) rotate(30deg);
    }

    ${p => p.theme.mq.upMd} {
      width: ${em(150)};
      height: ${em(150)};
      left: auto;
      right: 0;
      transform: translate(-5%, 40%) rotate(30deg);
    }
  }
`

export const ImageWrapper = styled.img`
  position: absolute;
  z-index: 4;
  -webkit-backface-visibility: hidden;

  &.shield {
    width: ${em(120)};
    bottom: 0;
    left: 0;

    ${p => p.theme.mq.upMd} {
      width: ${em(146)};
      right: 30%;
      top: -20%;
      bottom: auto;
      left: auto;
    }

    ${p => p.theme.mq.upLg} {
      right: 0;
    }
  }
`

export const Cover = styled.div`
  position: absolute;
  right: 0;
  height: 100%;
  background: ${p => p.theme.colors.grayOp06NonTransp};
  display: ${p => (p.isTablet ? 'none' : 'block')};
  ${p =>
    p.isTablet
      ? css`
          width: 59%;
        `
      : css`
          width: 90%;
        `}

  ${p => p.theme.mq.upMd} {
    display: ${p => (p.isTablet ? 'block' : 'none')};
  }

  ${p => p.theme.mq.upLg} {
    width: 60%;
  }
`
